(function ($) {    

    const $body = $('body')
    const $menuItem = $(".js-menu-item-with-submenu")
    const $headerNav = $('.js-header-nav')
    const desktopMinWidth = 1056

    let showSubmenuTimeout = null

    $menuItem
        .on("mouseenter", function() {
            if (window.innerWidth < desktopMinWidth) return
            const $self = $(this)
            clearTimeout(showSubmenuTimeout)
            showSubmenuTimeout = setTimeout(() => {
                const $submenu = $self.find(".js-submenu")
                $self.attr('data-open', true)
                $submenu
                    .stop()
                    .fadeIn(100)
            }, $(".js-submenu").is(":visible") ? 0 : 250)
        })
        .on("mouseleave", function() {
            if (window.innerWidth < desktopMinWidth) return
            clearTimeout(showSubmenuTimeout)
            setTimeout(() => {
                const $self = $(this)
                $self.removeAttr('data-open')
                $self
                    .stop()
                    .find(".js-submenu")
                    .fadeOut(100)
            }, 100)
        })
    
    $('.js-submenu-toggle-mobile')
        .on("click", function() {
            if (window.innerWidth >= desktopMinWidth) return
            const $self = $(this)
            const $menuListItem = $self.closest('.js-menu-item-with-submenu')
            const $submenu = $menuListItem.find(".js-submenu")
            const isOpen = $menuListItem.attr("data-open");
            if (isOpen) {
                $menuListItem.removeAttr("data-open")
            } else {
                $menuListItem.attr("data-open", true)    
            }
            $submenu.stop()
            if (isOpen) {
                $submenu.slideUp()
            } else {
                $submenu.slideDown()
            }
        })

    const $headerMenuToggleMobileButton = $('.js-header-menu-toggle-mobile')

    $headerMenuToggleMobileButton
        .on('click', function() {
            const $self = $(this)
            const isOpen = !!$headerNav.attr('data-open')
            $headerNav.stop()
            if (isOpen) {
                $self.removeAttr('data-open')
                $headerNav
                    .removeAttr('data-open')
                    .slideUp()
                $body.removeClass('mobile-menu-open')
            } else {
                $self.attr('data-open', true)
                $headerNav
                    .attr('data-open', true)    
                    .slideDown()
                $body.addClass('mobile-menu-open')
            }
        })
    
    $('.main-menu__item, .main-menu__cta-mobile-button').on('click', function() {
        const $self = $(this)
        const href = $self.attr('href')
        if (window.innerWidth >= desktopMinWidth
            || !href || !href.startsWith('#')) return
        $headerMenuToggleMobileButton.click()
    })

})(window.jQuery);
